import { observer } from "mobx-react"
import * as React from "react"
import { Modal } from "./Modal"
import ModalBackground from "./ModalBackground"
import ModalCardHeader from "./ModalCardHeader"
import ModalCardFooter from "./ModalCardFooter"
import ModalCard from "./ModalCard"
import ModalCardBody from "./ModalCardBody"
import ModalContainer from "./ModalContainer"
import ModalTitle from "./ModalTitle"
import ModalButton from "./ModalButton"
import { Flex, Text } from "rebass"
import theme from "../../theme"
import ModalClose from "./ModalClose"

@observer
export class ModalComp extends React.Component<{ model: () => Modal }> {
  render() {
    const { model } = this.props
    const modal = model()
    const {
      children,
      title,
      primaryDisabled,
      primaryButtonText,
      errorMessage
    } = modal

    return (
      <ModalContainer
        className="modal"
        style={{ color: theme.colors.modalText }}
      >
        {window.innerWidth > 480 ? <ModalBackground /> : null}
        <ModalCard
          className="modal-card"
          width={[1, 0.8, 0.7, 0.5]}
          mx={[0, 20]}
        >
          <ModalCardHeader className="modal-card-header">
            <ModalTitle className="modal-title">{title}</ModalTitle>
            <ModalClose
              className="modal-close"
              aria-label="close"
              onClick={() => {
                modal.onCancel && modal.onCancel()
              }}
            >
              <i className="fas fa-times-circle" />
            </ModalClose>
          </ModalCardHeader>
          <ModalCardBody className="modal-card-body">{children}</ModalCardBody>
          <ModalCardFooter className="modal-card-footer">
            {errorMessage && (
              <Flex flexDirection="column" mb={"2%"}>
                <Text
                  className="error-message"
                  style={{
                    fontSize: window.innerWidth > 400 ? "1.25rem" : "1rem",
                    color: "red"
                  }}
                >
                  {errorMessage}
                </Text>
              </Flex>
            )}
            <Flex flexDirection={"row"} width={[1]}>
              <ModalButton
                className="modal-button-secondary"
                secondary
                onClick={() => {
                  modal.onCancel && modal.onCancel()
                }}
              >
                Cancel
              </ModalButton>
              <ModalButton
                className="modal-button-primary"
                primary
                disabled={primaryDisabled}
                onClick={(event: any) => {
                  modal.onSave && modal.onSave()
                }}
              >
                {primaryButtonText}
              </ModalButton>
            </Flex>
          </ModalCardFooter>
        </ModalCard>
      </ModalContainer>
    )
  }
}
